// Define the function to import all components from a folder
const requireComponent = require.context("./", true, /\.vue$/);

// Register all components globally bu calling this function in main.js
export default (app) => {
  requireComponent.keys().forEach((fileName) => {
    const componentConfig = requireComponent(fileName);
    const componentName = fileName
      .split("/")
      .pop()
      .replace(/\.\w+$/, "");
    app.component(componentName, componentConfig.default || componentConfig);
  });
};
